import React from "react";

const WhatsAppIcon = ({ className = "w-5 h-5 text-white" }) => (
    <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
        className={className}
        aria-hidden="true"
    >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
);

/**
 * WhatsAppFloatingButton / WhatsAppButton
 * Botão estilizado do WhatsApp conforme a identidade visual da URBRACE.
 *
 * Pode ser utilizado fixo/flutuante (floating=true) ou inline (floating=false).
 */
export default function WhatsAppButton({
    phone = "5596981004733",
    message = "Olá, gostaria de falar com a equipe da URBRACE.",
    text = "Fale com a URBRACE",
    floating = true,
    className = "",
    style = {},
}) {
    const encodedMessage = encodeURIComponent(message);
    const cleanPhone = phone.replace(/\D/g, "");
    const href = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${text} via WhatsApp`}
            style={style}
            className={`
                group inline-flex items-center no-underline select-none
                transition-all duration-300 ease-out hover:scale-105 active:scale-95
                ${floating ? "fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 drop-shadow-2xl" : "relative"}
                ${className}
            `}
        >
            <div className="flex items-center bg-[#0B0F12]/95 hover:bg-black border border-[#25D366]/80 hover:border-[#25D366] rounded-full pl-3.5 sm:pl-4 pr-1 py-1 shadow-[0_0_15px_rgba(37,211,102,0.3)] hover:shadow-[0_0_25px_rgba(37,211,102,0.55)] backdrop-blur-md transition-all duration-300">
                {/* Indicador de status verde pulsante */}
                <span className="relative flex h-2.5 w-2.5 mr-2 sm:mr-2.5 shrink-0 items-center justify-center">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-[#25D366] shadow-[0_0_8px_#25D366]"></span>
                </span>

                {/* Texto do botão */}
                <span className="text-white text-xs sm:text-sm font-semibold tracking-tight whitespace-nowrap mr-2.5 sm:mr-3">
                    {text}
                </span>

                {/* Linha divisória vertical */}
                <span className="w-[1px] h-4 bg-white/20 mr-1.5 sm:mr-2 shrink-0"></span>

                {/* Círculo do WhatsApp com brilho verde neon */}
                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#25D366] flex items-center justify-center text-white shrink-0 shadow-[0_0_18px_rgba(37,211,102,0.85)] group-hover:shadow-[0_0_25px_rgba(37,211,102,1)] group-hover:rotate-6 transition-all duration-300">
                    <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5 fill-current text-white" />
                </div>
            </div>
        </a>
    );
}
